import top from "@/pages/global/components/top-bar/top-bar.vue";
import navigation from "@/pages/global/components/nav-bar/nav-bar.vue";
import bottom from "@/pages/global/components/bottom-bar/bottom-bar.vue";

import UsersCustomHits from '@/pages/administration/admin/app-advertisements/components/advertisements-custom-hit/advertisements-custom-hit.vue';

import {
    AisInstantSearch,
    AisRefinementList,
    AisHits,
    AisHighlight,
    AisSearchBox,
    AisStats,
    AisPagination,
    AisSortBy,
    AisHitsPerPage,
} from 'vue-instantsearch';
import algoliasearch from 'algoliasearch/lite';
import 'instantsearch.css/themes/algolia-min.css';

export default {
    data() {
        return {
            searchClient: algoliasearch(
                (location.hostname === "localhost") ? 'L48UIMMJKB' : 'NFR2QQSBTT',
                (location.hostname === "localhost") ? 'ce57f03c4e083aafc111c4ef0702032d' : 'd9ba91603e4e9e4fe0db95e6ec72cfba'
            ),
            tagType: "",
        };
    },
    components: {
        top,
        navigation,
        bottom,
        AisInstantSearch,
        AisRefinementList,
        AisHits,
        AisHighlight,
        AisSearchBox,
        AisStats,
        AisPagination,
        AisSortBy,
        AisHitsPerPage,
        UsersCustomHits,
    }
};


// WEBPACK FOOTER //
// ./src/pages/administration/admin/app-advertisements/master/app-advertisements.js